module.exports = __webpack_public_path__ + "img/icon_wrong.d52cdb9a.png";